export default __webpack_public_path__ + "static/media/StaticFluids.eb476baa.jpg";